import { ReactNode } from 'react'

import {
  Text,
  GreyGrey100,
  GreyGrey30,
  GreyWhite,
  Primary16SemiBold,
  ShadowL,
  Box,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { motion } from 'framer-motion'
import { StandardLayout } from '@sequencehq/core-components'

type Props = {
  children: ReactNode
  footer: ReactNode
  title: ReactNode
  onClose: () => void
  'data-testid'?: string
}

export const StepDrawer = ({
  children,
  footer,
  title,
  onClose,
  'data-testid': testId
}: Props) => {
  return (
    <motion.div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        flexDirection: 'column',
        zIndex: '2',
        alignItems: 'flex-end'
      }}
      initial={{ background: 'rgba(255, 255, 255, 0)' }}
      animate={{ background: 'rgba(255, 255, 255, 0.5)' }}
      exit={{ background: 'rgba(255, 255, 255, 0)' }}
      transition={{ duration: 0.2 }}
    >
      <motion.div
        onClick={e => {
          e.stopPropagation()
        }}
        style={{
          display: 'grid',
          width: '512px',
          flexDirection: 'column',
          height: '100%',
          overflowY: 'scroll',
          borderLeft: `${GreyGrey30} 1px solid`,
          boxShadow: ShadowL,
          gridTemplateRows: 'auto 1fr auto',
          gridTemplateAreas: `
          "header header header"
            "content content content"
            "footer footer footer"
          `,
          background: GreyWhite,
          position: 'relative'
        }}
        initial={{ right: '-512px' }}
        animate={{ right: '0px' }}
        exit={{ right: '-512px' }}
        transition={{ duration: 0.2 }}
      >
        <Grid
          data-testid={testId}
          gridTemplateColumns="1fr auto"
          gridArea="header"
          alignItems="center"
          padding="24px 24px 0 24px"
        >
          <Text {...Primary16SemiBold} color={GreyGrey100}>
            {title}
          </Text>
          <StandardLayout.ButtonClose onClick={onClose} />
        </Grid>
        <Box padding="16px 24px" gridArea="content" overflowY="auto">
          {children}
        </Box>
        <GridItem
          gridArea="footer"
          width="100%"
          borderTop={`${GreyGrey30} 1px solid`}
          padding="8px"
          display="flex"
          gap="8px"
          justifyContent="flex-end"
        >
          {footer}
        </GridItem>
      </motion.div>
    </motion.div>
  )
}
